import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import L from 'leaflet';
import { MapContainer, Marker, TileLayer, useMapEvent } from 'react-leaflet';
import { Icon } from '@lomarengas/design-system';
import DemoImage1 from '../../../assets/img/crosshair@2x.png';

export interface MapPickerProps {
  HandleSelect: (Lat: number, Lng: number) => void;
  Height?: number;
  Latitude?: number;
  Longitude?: number;
  Zoom?: number;
  Disabled?: boolean;
}

const MapPicker = ({
  HandleSelect,
  Height = 500,
  Latitude = null,
  Longitude = null,
  Zoom = 6,
  Disabled = false,
}: MapPickerProps) => {
  // 64, 26 = About Finland's center
  const defaultLat = 64;
  const defaultLng = 26;

  const [centerLat, setCenterLat] = useState<number>(defaultLat);
  const [centerLng, setCenterLng] = useState<number>(defaultLng);
  const [lat, setLat] = useState<number>(null);
  const [lng, setLng] = useState<number>(null);

  const iconPerson = new L.Icon({
    iconUrl: DemoImage1,
    iconAnchor: new L.Point(25, 25),
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon',
  });

  const SetCoordinates = (Lat: number, Lng: number) => {
    setLat(Lat);
    setLng(Lng);
    setCenterLat(Lat);
    setCenterLng(Lng);
    HandleSelect(Lat, Lng);
  };

  function ClickComponent() {
    const map = useMapEvent('click', e => {
      const wrapped = e.latlng.wrap();
      SetCoordinates(wrapped.lat, wrapped.lng);
    });
    return null;
  }

  useEffect(() => {
    if (
      Latitude !== null &&
      Longitude !== null &&
      Latitude > 0 &&
      Longitude > 0
    ) {
      setCenterLat(Latitude);
      setCenterLng(Longitude);
    } else {
      setCenterLat(defaultLat);
      setCenterLng(defaultLng);
    }
  }, []);

  useEffect(() => {
    if (
      Latitude !== null &&
      Longitude !== null &&
      Latitude > 0 &&
      Longitude > 0
    ) {
      SetCoordinates(Latitude, Longitude);
    }
  }, [Latitude, Longitude]);

  return (
    <Dropdown className="position-static">
      <Dropdown.Toggle
        disabled={Disabled}
        id="dropdown-mappicker"
        variant="primary"
      >
        <Icon CssClass="me-16" Name="geo-alt-fill" />
        Valitse kartalta
      </Dropdown.Toggle>
      <Dropdown.Menu className="bg-white mappicker p-8 shadow" flip={false}>
        <MapContainer
          center={[centerLat, centerLng]}
          zoom={Zoom}
          scrollWheelZoom
          style={{ height: Height }}
        >
          <ClickComponent />
          {centerLat !== null && centerLat !== null && (
            <Marker
              draggable
              eventHandlers={{
                dragend: e => {
                  const wrapped = e.target.getLatLng().wrap();
                  SetCoordinates(wrapped.lat, wrapped.lng);
                },
              }}
              icon={iconPerson}
              position={[centerLat, centerLng]}
            />
          )}
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        </MapContainer>
      </Dropdown.Menu>
    </Dropdown>
  );
};

// MapPicker.defaultProps = {
//   Height: 500,
//   Latitude: null,
//   Longitude: null,
//   Zoom: 6,
// };

export default MapPicker;
export { MapPicker };
